
import { Box } from "@mui/material";
import { useProductosQuery } from "../../../hooks";
import { DisenioPaginas } from "../../layout";
import { BuscadorSoloValor, CargandoMedio, TablaListProductos } from "../../components";




export const ListadoProductos = () => {


    const { productosListQuery, page, termino, chagePage, chageTermino } = useProductosQuery()
    

    return (

        <DisenioPaginas titulo="Listado de Productos" url="add/producto">
            {(productosListQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Bodegas..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} 
                    titulo='Buscar producto.' place='Buscar x nombre, medida proveedor...'
                />
                <TablaListProductos data={productosListQuery.data || []} chagePage={chagePage} page={page} />
                </>
            }

            <Box sx={{height:30}} />
        </DisenioPaginas>
    )
}
